import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { FormPopupProvider } from './contexts/FormPopupContext';
import { ConsentProvider } from './contexts/ConsentContext';
import { CrmAuthProvider } from './contexts/CrmAuthContext';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import { CounselorAuthProvider } from './contexts/CounselorAuthContext';
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ConsentProvider>
          <FormPopupProvider>
            <CrmAuthProvider>
              <AdminAuthProvider>
                <CounselorAuthProvider>
                  <App />
                </CounselorAuthProvider>
              </AdminAuthProvider>
            </CrmAuthProvider>
          </FormPopupProvider>
        </ConsentProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);
